import Styles from "./Navbar.module.scss";
import logo from "../../assets/images/logo/LOGO.png";
import classNames from "classnames";
import Hamburger from "../Hamburger/Hamburger";
import React from "react";
import Close from "../Hamburger/Close";

const Navbar = () => {
  const [openMenu, setOpenMenu] = React.useState(false);
  const [isOpen, setIsOpen] = React.useState(false);
  const handleOpenMenu = () => {
    setOpenMenu(!openMenu);
  };

  const closeMenu = () => {
    console.log(openMenu);
    setOpenMenu(false);
  };

  return (
    <nav className={classNames("col-12", Styles.navbar)}>
      <div className={classNames("container", Styles.navbar__head)}>
        <a href="/">
          <div className={Styles.navbar__brand}>
            <img src={logo} alt="Logo" className={Styles.navbar__logo} />
            <span className={Styles.navbar__title}>
              社團法人中華廣博
              <br />
              長照發展協會
            </span>
          </div>
        </a>
        <div onClick={handleOpenMenu}>
          <Hamburger />
        </div>
        <ul
          className={openMenu ? Styles.navbar__menu__open : Styles.navbar__menu}
        >
          {/* <ul
            className={classNames(
              Styles.navbar__menu,
              openMenu && Styles["navbar__menu__open"]
            )}
          ></ul> */}
          <div onClick={closeMenu}>
            <Close />
          </div>
          <a href="/aboutus">
            <li onClick={closeMenu}>關於我們</li>
          </a>
          <a onClick={closeMenu} href="/news">
            <li>最新消息</li>
          </a>


          <li onMouseEnter={() => setIsOpen(true)}
            onMouseLeave={() => setIsOpen(false)}
          >
            <a
              // 
              onClick={closeMenu} href="/service">社會服務</a>
            {isOpen && (<ul
              onMouseEnter={() => setIsOpen(true)}
              onMouseLeave={() => setIsOpen(false)}
              className={classNames(Styles.navbar__submenu)} >

              <li>
                <a href="/service/短期臨托">
                  短期臨托
                </a>
              </li>
              <li>
                <a href="/service/長照巴士預約">
                  長照巴士預約
                </a>
              </li>
              <li>
                <a href="/service/長照居家困境協助">
                  長照居家困境協助
                </a>
              </li>
              {/* <li>
                <a href="/service/幸福二之一">
                  幸福二之一
                </a>
              </li>

              <li>
                <a href="/service/偏鄉身障圓夢計畫">
                  偏鄉身障圓夢計畫
                </a>
              </li> */}
            </ul>)}

          </li>

          <a onClick={closeMenu} href="/duty">
            <li>社會責信</li>
          </a>

          <a onClick={closeMenu} href="/story">
            <li>他們的故事</li>
          </a>

          <a onClick={closeMenu} href="/join">
            <li>加入我們</li>
          </a>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
